





































































































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import api from "../store/api";
import { IAccountDetails, IAssessment } from "../store/main.interfaces";
import AccountCreationForm from "../components/account-creation-form.vue";
import { TranslateResult } from "vue-i18n";
import user from "../store/modules/user";
import { createEmptyUserObject } from "../store/user.util";

@Component({
  components: { AccountCreationForm }
})
export default class AdministrationView extends Vue {
  userObject: IAccountDetails = createEmptyUserObject();
  userAccounts: IAccountDetails[] | null = null;
  accountCreationDialog: boolean = false;
  accountEditingDialog: boolean = false;
  groupBy: string | null = null;
  dialogText: string | TranslateResult = "";
  dialog: boolean = false;
  privilegeRestriction: string = "WRITE_USERS";

  data() {
    return {
      headers: [
        {
          text: this.$t("generics.terms.username"),
          align: "start",
          value: "username",
          explanation: this.$t("views.accountAdministration.tooltip.username")
        },
        {
          text: this.$t("generics.terms.organization"),
          align: "center",
          value: "organization",
          explanation: this.$t("views.accountAdministration.tooltip.organization")
        },
        {
          text: this.$t("generics.terms.roles"),
          align: "center",
          value: "roles",
          explanation: this.$t("views.accountAdministration.tooltip.roles")
        },
        {
          text: this.$t("generics.terms.id"),
          align: "center",
          value: "id",
          explanation: this.$t("views.accountAdministration.tooltip.id")
        },
        {
          text: this.$tc("generics.terms.process", 2),
          align: "center",
          value: "numberOfAssessments",
          explanation: this.$t("views.accountAdministration.tooltip.assessmentNumber")
        },
        {
          text: "",
          align: "center",
          value: "buttons"
        }
      ]
    };
  }

  async createAccount(userObject: IAccountDetails) {
    if (
      userObject.username !== "" &&
      userObject.password !== "" &&
      userObject.organization !== "" &&
      userObject.email !== "" &&
      userObject.roles.length > 0
    ) {
      const createAccountResponse = await api.createAccount(userObject);
      if (createAccountResponse === false) {
        this.dialogText = this.$t("dialogs.createAccount.onError") as string;
        this.dialog = true;
      } else {
        this.dialogText = this.$t("dialogs.createAccount.onSuccess", { user: userObject.username });
        this.dialog = true;
      }
      this.accountCreationDialog = false;
    } else {
      this.dialogText = this.$t("messages.fillAllFields");
      this.dialog = true;
    }
  }

  openAccountEditingDialog(accountItem: IAccountDetails) {
    this.userObject = createEmptyUserObject();
    Object.assign(this.userObject, accountItem);
    this.accountEditingDialog = true;
  }

  openAccountCreationDialog() {
    this.userObject = createEmptyUserObject();
    this.accountCreationDialog = !this.accountCreationDialog;
  }

  async editAccount(userObject: IAccountDetails) {
    if (
      userObject.username !== "" &&
      userObject.organization !== "" &&
      userObject.email !== "" &&
      userObject.roles.length > 0
    ) {
      const accountEditingResponse = await api.updateUserAccount(userObject, userObject.id!);
      if (accountEditingResponse === false) {
        this.dialogText = this.$t("dialogs.updateAccount.onError") as string;
        this.dialog = true;
      } else {
        this.dialogText = this.$t("dialogs.updateAccount.onSuccess", {
          user: userObject.username
        });
        this.dialog = true;
        user.loginWithoutUsername();

        // TODO replace this with a more efficient load function
        // currently not urgent, the confirmation dialog covers up the loading time
        await this.loadUsers();
      }
      this.accountEditingDialog = false;
    } else {
      this.dialogText = this.$t("messages.fillAllFields");
      this.dialog = true;
    }
  }
  async showUserProcesses(account: IAccountDetails) {
    if (account.numberOfAssessments && account.numberOfAssessments > 0) {
      this.$emit("showUserProcesses", account);
    }
  }
  onRowClick(item: IAccountDetails, context: any) {
    context.select(!context.isSelected);
  }

  changeGroupBy() {
    this.groupBy = this.groupBy === "organization" ? null : "organization";
  }
  async created() {
    await this.loadUsers();
  }
  async loadUsers() {
    this.userAccounts = await api.getAllUserAccounts();
  }
}
